import { render, staticRenderFns } from "./ManagementServicesList.vue?vue&type=template&id=70a15875"
import script from "./ManagementServicesList.vue?vue&type=script&lang=js"
export * from "./ManagementServicesList.vue?vue&type=script&lang=js"
import style0 from "./ManagementServicesList.vue?vue&type=style&index=0&id=70a15875&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports